import { render, staticRenderFns } from "./PropertiesAddRemoveDialog.vue?vue&type=template&id=073390a8&scoped=true&"
import script from "./PropertiesAddRemoveDialog.vue?vue&type=script&lang=js&"
export * from "./PropertiesAddRemoveDialog.vue?vue&type=script&lang=js&"
import style0 from "./PropertiesAddRemoveDialog.vue?vue&type=style&index=0&id=073390a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073390a8",
  null
  
)

export default component.exports